export default "__VITE_ASSET__dee7b219__"